import React, { useEffect, useState } from "react";
import { MwButton } from "../../ui";
import CardHeadeWithActions from "../../ui/CardHeadeWithActions";
import GroupForm from "./GroupForm";
import { langObjType, objLangTextHandler } from "../../../utils/global";
import { useCurrent, usePost } from "../../../hooks";
import { useTranslation } from "react-i18next";
import { invalidateFetchCache } from "../../../hooks/useFetch";

const CreateGroup = ({ onHide, setMode }) => {
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangList, currentLangId } =
    useCurrent();
  const [t] = useTranslation("global");
  const [errors, setErrors] = useState({});
  const { data: resultPost, postData } = usePost();
  const [formLang, setFormLang] = useState(currentLangId);

  const [groupName, setGroupName] = useState(langObjType());
  const [groupDesc, setGroupDesc] = useState(langObjType());
  const [isActive, setIsActive] = useState(true);

  const formValidate = () => {
    let errorObj = {};
    if (!groupName[currentLangId]) {
      errorObj = { ...errorObj, [`groupName.${currentLangId}`]: t("customers.groupNameRequired") };
    }
    if (Object.keys(errorObj).length !== 0) {
      setErrors(errorObj);
      return true;
    }
    return false;
  };

  const saveHandler = () => {
    if (formValidate()) return;
    const _data = {
      groupName: objLangTextHandler(groupName),
      groupDesc: objLangTextHandler(groupDesc),
      isActive,
      tenantId: currentTenantId,
      companyId: currentCompanyId,
      branchId: currentBranchId,
    };
    postData(`${process.env.REACT_APP_Auth_API_BASE_URL}/customers/groups`, _data);
  };

  const cancelHandle = () => {
    onHide ? onHide() : setMode("List");
  };

  useEffect(() => {
    if (resultPost) {
      const groupsListUrl =
        currentTenantId && currentCompanyId && currentBranchId
          ? `${process.env.REACT_APP_Auth_API_BASE_URL}/customers/groups/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
          : null;
      invalidateFetchCache(groupsListUrl);
      cancelHandle();
    }
  }, [
    resultPost,
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    onHide,
    setMode,
  ]);

  return (
    <div className={`${onHide && "p-5"}`}>
      <CardHeadeWithActions title={t("customers.addNewGroup")}>
        {onHide && (
          <MwButton inGroup={true} type="cancelBtn" onClick={cancelHandle}>
            {t("customers.cancel")}
          </MwButton>
        )}
        <MwButton inGroup={true} type="cancelBtn" onClick={() => setMode("List")}>
          {t("customers.customerGroupsList")}
        </MwButton>
        <MwButton actionType={`button`} inGroup={true} onClick={saveHandler} type="saveBtn">
          {t("customers.save")}
        </MwButton>
      </CardHeadeWithActions>
      <GroupForm
        currentLangList={currentLangList}
        formLang={formLang}
        setFormLang={setFormLang}
        errors={errors}
        groupName={groupName}
        setGroupName={setGroupName}
        groupDesc={groupDesc}
        setGroupDesc={setGroupDesc}
        isActive={isActive}
        setIsActive={setIsActive}
      />
    </div>
  );
};

export default CreateGroup;
